import AreaIcon from './../../../assets/icons/area.svg';

// https://www.iconfinder.com/icons/2739118/door-entrance-exit-icon
import DoorIcon from './../../../assets/icons/door.svg';
import DoorIconComponent from './DoorIcon.vue';

// https://www.iconfinder.com/icons/2324134/emergency-exit-stairs-stairway-icon (with arrow removed)
import StairsIcon from './../../../assets/icons/stairs.svg';
import StairsIconComponent from './StairsIcon.vue';

export {DoorIconComponent as DoorIcon, StairsIconComponent as StairsIcon};

import {EstimateEstateType} from '@/model/api';
import defaultParameterIcons from './parameters/default';
import familyHouseParameterIcons from './parameters/family_house';
import recreationalParameterIcons from './parameters/recreational';

const EnumIconMap = {
    default: defaultParameterIcons,
    flat: {} as IconList,
    family_house: familyHouseParameterIcons,
    land: {} as IconList,
    garage: {} as IconList,
    recreational: recreationalParameterIcons,
};

interface IconList {
    [iconId: string]: SvgSymbolData;
}

const allEnumIcons: IconList = {};

Object.entries(EnumIconMap).forEach(([estateType, icons]) => {
    if (estateType === 'default') {
        Object.assign(allEnumIcons, icons);
        return;
    }

    Object.entries(icons).forEach(([iconId, iconData]) => {
        allEnumIcons[estateType + '-' + iconId] = iconData;
    });
});

export default {
    groundplan: AreaIcon,
    door: DoorIcon,
    stairs: StairsIcon,
    ...allEnumIcons,
};

export interface SvgSymbolData {
    id: string;
    width: string;
    height: string;
    viewBox: string;
    url: string;
}

export function iconsForEstateType(estateType: EstimateEstateType): IconList {
    return {...EnumIconMap.default, ...EnumIconMap[estateType]};
}

export function enumIconName(parameterId: string, optionId: string): string {
    return `${parameterId}-${optionId}`;
}
